import React, { FunctionComponent } from "react";

import { LogoutButton } from "../LogoutButton";
import { MenuComponent, MenuComponentContentPosition } from "../MenuComponent";
import { MenuTitle } from "../MenuTitle";
import { ToggleThemeButton } from "../ToggleThemeButton";
import { UserMenuComponentProps } from "./UserMenuComponentProps";

export { UserMenuComponentProps };

/** Komponenta představuje sekci pro uživatele. */
export const UserMenuComponent: FunctionComponent<UserMenuComponentProps> = ({ title, userName, onMenuTitleClick }) => (
    <MenuComponent contentPosition={MenuComponentContentPosition.bottom} headerContent={
        <MenuTitle
            text={title}
            onClick={onMenuTitleClick}
            subtitle={userName}/>}
    >
        <ToggleThemeButton />
        <LogoutButton />
    </MenuComponent>
);
